import { render, staticRenderFns } from "./unitverifycheck.vue?vue&type=template&id=3672c79e&scoped=true"
import script from "./unitverifycheck.vue?vue&type=script&lang=js"
export * from "./unitverifycheck.vue?vue&type=script&lang=js"
import style0 from "./unitverifycheck.vue?vue&type=style&index=0&id=3672c79e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3672c79e",
  null
  
)

export default component.exports